import { permissionsSelectors } from 'ducks/permissions'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'

const useHardwareSelectorV2Columns = () => {
  const enabledMultiDistributorSelector = useFeatureFlag('design_multi_distributor', 'on')
  const hardwareSourceSelectionPermission = useSelector((state) =>
    permissionsSelectors.getPermissionByKey(state, 'hardware_source_selection')
  )

  const showDistributorSelection = useMemo(() => {
    if (enabledMultiDistributorSelector) {
      return hardwareSourceSelectionPermission.allowView
    }
    return true
  }, [hardwareSourceSelectionPermission.allowView, enabledMultiDistributorSelector])

  return {
    showDistributorSelection,
  }
}

export default useHardwareSelectorV2Columns
